export default __webpack_public_path__ + "static/media/hiringpage.984f116d.png";